export default __webpack_public_path__ + "static/media/bayad-center@2x.bc7c7ecc.png";